import React, { forwardRef, useEffect, useState } from 'react'
import { Button, Modal } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
// import "react-datepicker/dist/react-datepicker.css";

const formatLocalDate = (date) => {
  if (!date) return "";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const ExamPopup = ({ isOpen, toggle, submit, examDate }) => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (examDate && new Date(examDate) > new Date()) {
      setSelectedDate(new Date(examDate));
    } else {
      setSelectedDate(new Date());
    }
  }, [examDate]);

  const handleSubmit = async (e) => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      await submit(e, formatLocalDate(selectedDate));
    } finally {
      setIsSubmitting(false);
    }
  };

  const CustomDateInput = forwardRef(({ value, onClick }, ref) => (
    <div className="w-100" onClick={onClick} ref={ref}>
      <div className="voice-dropdown-toggle w-100 d-flex justify-content-between align-items-center px-2 btn btn-light" style={{ backgroundColor: "white", color: "black", border: "1px solid #ced4da" }}>
        <span>{value || "Select Date"}</span>
      </div>
    </div>
  ));

  return (
    <Modal show={isOpen} centered className="text-translate-modal exam-date-popup">
      <Modal.Header className="text-translation d-flex justify-content-between align-items-center" tag="div">
        <p className='FS20FW500'>Set Exam Date</p>
        <Button className="modalCloseBtn" onClick={() => toggle()}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="24"
            height="24"
          >
            <path
              d="M18 6L6 18M6 6l12 12"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Button>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="w-100">
            <DatePicker
              selected={selectedDate}
              onChange={(date) => setSelectedDate(date)}
              minDate={new Date()}
              customInput={<CustomDateInput />}
              calendarClassName="custom-calendar-300"
              popperPlacement="bottom-start"
              dateFormat="yyyy-MM-dd"
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="close-button"
          onClick={handleSubmit}
          disabled={isSubmitting}
        >
          {isSubmitting ? "Saving..." : "Save Exam Date"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ExamPopup
